// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2bi0y","col":"Table_col__3b9qx","fulfillmentStatus":"Table_fulfillmentStatus__1Tlal","emailCol":"Table_emailCol__2cYv8"};